module.exports = __webpack_public_path__ + "media/images/admin2/Filter__panel__handle__a-2a87cda34a62e28db41f31308e126603.svg";